import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faInstagram,
  faTwitter,
  faYoutube,
  faFacebook,
} from "@fortawesome/free-brands-svg-icons";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-div">
        <div className="footer-top">
          <Link to="/">HungryHub</Link>
          <div className="footer-social-links">
            <p>Social Links</p>
            <div>
              <a href="https://www.linkedin.com">
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
              <a href="https://www.instagram.com">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="https://www.twitter.com">
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a href="https://www.youtube.com">
                <FontAwesomeIcon icon={faYoutube} />
              </a>
              <a href="https://www.facebook.com">
                <FontAwesomeIcon icon={faFacebook} />
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="contact-button">
            <Link to={"/contact"}>
              <button>Contact Us</button>
            </Link>
          </div>
          <div className="download-buttons">
            <a href="https://play.google.com/">
              <img src={require("../images/android.webp")} alt="PlayStore" />
            </a>
            <a href="https://www.apple.com/in/app-store/">
              <img src={require("../images/iOS.webp")} alt="AppStore" />
            </a>
          </div>
        </div>
      </div>
      <hr />
      <p>
        By continuing past this page, you agree to our Terms of Service, Cookie
        Policy, Privacy Policy and Content Policies. All trademarks are
        properties of their respective owners.© 2023 HungryHub. All rights
        reserved.
      </p>
    </footer>
  );
};

export default Footer;
